module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft--dark-d6af79331426f1149195632a8e42d828.png";